/**
 * MUI component style overrides and configurations.
 * This module defines custom styling for Material UI components globally.
 */

import OpenSansRegularWoff from '../assets/fonts/open-sans-v34-latin-regular.woff';
import OpenSansRegularWoff2 from '../assets/fonts/open-sans-v34-latin-regular.woff2';
import OpenSansRegularEot from '../assets/fonts/open-sans-v34-latin-regular.eot';
import OpenSansRegularTtf from '../assets/fonts/open-sans-v34-latin-regular.ttf';
import OpenSansRegularSvg from '../assets/fonts/open-sans-v34-latin-regular.svg';

export const componentOverrides = {
  MuiCssBaseline: {
    styleOverrides: `
    /* open-sans-regular - latin */
    @font-face {
      font-family: 'Open Sans';
      font-style: normal;
      font-weight: 400;
      src: url(${OpenSansRegularEot}); /* IE9 Compat Modes */
      src: local(''),
           url(${OpenSansRegularEot}) format('embedded-opentype'), /* IE6-IE8 */
           url(${OpenSansRegularWoff2}) format('woff2'), /* Super Modern Browsers */
           url(${OpenSansRegularWoff}) format('woff'), /* Modern Browsers */
           url(${OpenSansRegularTtf}) format('truetype'), /* Safari, Android, iOS */
           url(${OpenSansRegularSvg}) format('svg'); /* Legacy iOS */
    }
    `,
  },
};
